import Vue from "vue";
import Router from "vue-router";
import Home from "./components/Home.vue";
import SetupCompletion from "./components/views/page/SetupCompletion.vue";
import False from "./components/views/page/False.vue";

Vue.use(Router);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/Completion',
        name: "SetupCompletion",
        component: SetupCompletion,
        props: route => ({ elapsedTime: route.params.elapsedTime }),
    },
    {
        path: "/false",
        name: "False",
        component: False,
    }
];
const router = new Router({
    mode: 'history',
    routes,
});

export default router;
